import React, { useEffect, useState } from "react";
import api from "../services/api";
import "./Home.css";
import { FaWhatsapp } from "react-icons/fa";

export default function Home() {
  const [company, setCompany] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [showHalalModal, setShowHalalModal] = useState(false);

  const formatRupiah = (angka) => {
    if (angka === null || angka === undefined) return "-";
    return "Rp " + angka.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const renderPriceRange = (min, max) => {
    if (!min || !max) return "Harga belum tersedia";
    if (Number(min) === Number(max)) return formatRupiah(min);
    return `${formatRupiah(min)} - ${formatRupiah(max)}`;
  };

  const extractMapSrc = (iframeString) => {
    if (!iframeString) return null;
    const match = iframeString.match(/src="([^"]+)"/);
    return match ? match[1] : null;
  };

  useEffect(() => {
    // Fetch company profile
    api.get("/company-profile")
      .then(res => setCompany(res.data))
      .catch(() => setCompany(null));

    // Fetch products & parse images/tags JSON
     api.get("/products")
    .then(res => {
      const parsedProducts = res.data.map(p => ({
        ...p,
        images: Array.isArray(p.images) 
                  ? p.images 
                  : p.images ? JSON.parse(p.images) : [],
        tags: p.tags ? JSON.parse(p.tags) : [],
      }));
      setProducts(parsedProducts);
    })
    .catch(() => setProducts([]));
  }, []);

  useEffect(() => {
     if (selectedProduct && Array.isArray(selectedProduct.images) && selectedProduct.images.length > 0) {
    // Ambil gambar pertama sebagai mainImage
    setMainImage(`https://portofolio-tri.my.id/rinaldisupplier/uploads/${selectedProduct.images[0]}`);
  } else {
    setMainImage(""); // reset kalau tidak ada gambar
  }
  }, [selectedProduct]);

  const trackProductClick = async (productId) => {
    const key = `clicked_${productId}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "true");
    try {
      await api.post(`https://portofolio-tri.my.id/rinaldisupplier/rinaldisupplier/api/products/${productId}/click`);
    } catch (err) {
      console.error("Click tracking failed");
    }
  };

  const [showVisionMission, setShowVisionMission] = useState(false);


  return (
    <div className="home-container">
      {/* Navbar */}
      <nav className="navbar" style={{ backgroundColor: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", position: "sticky", top: 0, zIndex: 1000, width: "100%" }}>
        <div className="navbar-inner" style={{ maxWidth: "1400px", margin: "0 auto", padding: "1rem 3rem", display: "flex", alignItems: "center" }}>
          <div className="nav-logo" style={{ display: "flex", alignItems: "left", gap: "0.5rem", fontWeight: 700, fontSize: "1.6rem", color: "#007bff", marginRight:"3.5rem" }}>
            <img src="/logo.jpg" alt="Rinaldi Supplier" style={{ height: "40px", marginRight: "0.5rem" }} />
            Rinaldi Supplier
          </div>
          <div className="nav-right" style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "1.4rem" }}>
            <a href="#products" style={{ textDecoration: "none", color: "#555", fontWeight: 500 }}>Produk</a>
            <a href="#about" style={{ textDecoration: "none", color: "#555", fontWeight: 500 }}>Tentang</a>
            <a href="#contact" style={{ textDecoration: "none", color: "#555", fontWeight: 500 }}>Kontak</a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">Fresh & High-Quality Seafood Supplier in <span>Indonesia</span></h1>
          <p className="hero-subtitle">Supplying premium ocean-fresh seafood for restaurants, hotels, businesses, and households</p>
          <a href="#products" className="hero-cta">Lihat Produk</a>
        </div>
      </header>

      {/* Company Profile */}
      <section id="about" className="company-profile">
        <div className="company-wrapper">
          <img src="/logo.jpg" alt="Logo" className="company-logo" />
          <div className="company-info">
            <h2>{company?.nama_perusahaan || "Rinaldi Supplier"}</h2>
            <p>{company?.deskripsi}</p>

            <div className="company-certification" onClick={() => setShowHalalModal(true)}>
              <img src="/sertifikat-halal.png" alt="Halal Certification" />
              <span>Official Halal Certification</span>
            </div>

            <div
  className="vision-mission-container"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "2rem auto",
    maxWidth: "800px",
    padding: "1rem",
  }}
>
  <button
    className="vision-mission-toggle"
    onClick={() => setShowVisionMission(prev => !prev)}
    style={{
      backgroundColor: "#0d6efd",
      color: "#fff",
      border: "none",
      padding: "0.75rem 1.5rem",
      fontSize: "1rem",
      fontWeight: 600,
      borderRadius: "8px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    }}
    onMouseEnter={e => e.currentTarget.style.backgroundColor = "#084298"}
    onMouseLeave={e => e.currentTarget.style.backgroundColor = "#0d6efd"}
  >
    Visi & Misi
  </button>

  {showVisionMission && (
    <div
      className="vision-mission-content"
      style={{
        marginTop: "1rem",
        padding: "1rem 1.5rem",
        backgroundColor: "#f8f9fa",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        width: "100%",
        textAlign: "center",
      }}
    >
      <h3 style={{ marginTop: "0.5rem", marginBottom: "0.5rem", color: "#0d6efd" }}>Visi</h3>
     <p style={{ marginBottom: "1rem", color: "#212529", lineHeight: 1.6 }}>
  Menjadi penyedia ikan laut segar terkemuka di Indonesia dengan fokus pada kualitas, keberlanjutan, dan kepercayaan pelanggan. Kami berkomitmen menghadirkan produk laut langsung dari nelayan lokal dengan standar higienis tinggi, menjaga kesegaran dan nilai gizi bagi seluruh konsumen, mulai dari rumah tangga hingga industri kuliner.
</p>

<h3 style={{ marginTop: "0.5rem", marginBottom: "0.5rem", color: "#0d6efd" }}>Misi</h3>
<p style={{ marginBottom: "1rem", color: "#212529", lineHeight: 1.6 }}>
  1. Menjalin kemitraan yang kuat dan berkelanjutan dengan nelayan lokal untuk memastikan pasokan ikan yang segar dan beretika.<br />
  2. Meningkatkan distribusi ikan laut secara efisien melalui sistem logistik modern agar produk sampai ke konsumen dalam kondisi terbaik.<br />
  3. Menjaga standar higienis dan kualitas tinggi di setiap tahap, mulai dari penangkapan, pengolahan, hingga pengiriman.<br />
  4. Mendukung usaha kuliner, restoran, dan rumah tangga dengan menyediakan produk laut yang terpercaya, berkualitas, dan beragam.<br />
  5. Mengedukasi masyarakat tentang pentingnya konsumsi ikan segar dan keberlanjutan sumber daya laut.
</p>

    </div>
  )}
</div>

            <div className="company-links">
              {company?.shopee && <a href={company.shopee} target="_blank">Shopee</a>}
              {company?.tokopedia && <a href={company.tokopedia} target="_blank">Tokopedia</a>}
              {company?.instagram && <a href={company.instagram} target="_blank">Instagram</a>}
              {company?.tiktok && <a href={company.tiktok} target="_blank">TikTok</a>}
            </div>
          </div>
        </div>
      </section>

      {/* Product Catalog */}
      <section id="products" className="product-catalog">
        <h2>Katalog Produk</h2>
       <div className="product-grid">
  {products.length > 0 ? (
    products.map(p => (
      <div key={p.id} className="product-card" onClick={() => {
  trackProductClick(p.id); 
  setSelectedProduct(p);
  if (Array.isArray(p.images) && p.images.length > 0) {
    setMainImage(`https://portofolio-tri.my.id/rinaldisupplier/uploads/${p.images[0]}`);
  } else {
    setMainImage("");
  }
}}
>
        <div className="product-image">
          <img 
            src={p.images?.[0] || "/placeholder.png"} 
            alt={p.nama_produk} 
            style={{ width: "100%", height: "200px", objectFit: "cover" }}
          />
        </div>
        <div className="product-card-content">
          <h3>{p.nama_produk}</h3>
          <p className="price">{renderPriceRange(p.min_price, p.max_price)}</p>
        </div>
      </div>
    ))
  ) : (
    <p>Belum ada produk</p>
  )}
</div>
      </section>

      {/* Halal Modal */}
      {showHalalModal && (
        <div className="modal-overlay" onClick={() => setShowHalalModal(false)}>
          <div className="modal-content" style={{ maxWidth: "700px" }} onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowHalalModal(false)}>×</button>
            <h2 style={{ textAlign: "center" }}>Halal Certification</h2>
            <img src="/sertifikat-halal.png" alt="Halal Certificate" style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }} />
          </div>
        </div>
      )}

      {/* Product Modal */}
{/* Product Modal */}
{selectedProduct && (
  <div className="modal-overlay" onClick={() => setSelectedProduct(null)}>
    <div className="modal-content" onClick={e => e.stopPropagation()}>
      <button className="modal-close" onClick={() => setSelectedProduct(null)}>×</button>
      <div className="modal-header">
        <h2>{selectedProduct.nama_produk}</h2>
      </div>
      <div className="modal-body">
        {/* Main Image */}
        {mainImage && <img src={mainImage} alt={selectedProduct.nama_produk} className="modal-main-image" />}

        {/* Thumbnails */}
        <div className="modal-images">
          {Array.isArray(selectedProduct.images) && selectedProduct.images.map((img, i) => (
            <img
              key={i}
              src={img} // URL sudah full dari backend
              alt={`thumb-${i}`}
              onClick={() => setMainImage(img)}
            />
          ))}
        </div>

        {/* Description & Price */}
        <p className="modal-description">{selectedProduct.description}</p>
        <p className="modal-price">{renderPriceRange(selectedProduct.min_price, selectedProduct.max_price)}</p>

        {/* Variants */}
        {selectedProduct.variants && selectedProduct.variants.length > 0 ? (
          <div className="variant-stock">
            <h4>Pilihan & Stok</h4>
            {selectedProduct.variants.map(v => (
              <div key={v.id} className="variant-item">
                <div>
                  <strong>
                    <div className="variant-meta">Berat: {v.berat_gram} gr</div>
                  </strong>
                </div>
                <div className="variant-right">
                  <div className="variant-price">{formatRupiah(v.harga)}</div>
                  <div className={v.stok > 0 ? "in-stock" : "out-stock"}>
                    {v.stok > 0 ? `Stok: ${v.stok}` : "Habis"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : <p>Varian belum tersedia</p>}

        {/* WhatsApp Order */}
        {company?.whatsapp && (
          <a
            href={`https://wa.me/${company.whatsapp.replace(/\s/g,'')}?text=Saya%20ingin%20memesan%20${encodeURIComponent(selectedProduct.nama_produk)}`}
            target="_blank"
            className="modal-wa-button"
          >
            Order via WhatsApp
          </a>
        )}

        {/* Video */}
        {selectedProduct.video && (
          <video controls className="modal-video">
            <source src={selectedProduct.video} type="video/mp4" />
          </video>
        )}
      </div>
    </div>
  </div>
)}


      {company?.google_maps && extractMapSrc(company.google_maps) && (
        <div className="map-container">
          <iframe
            src={extractMapSrc(company.google_maps)}
            width="100%"
            height="300"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            title="Lokasi Perusahaan"
          />
        </div>
      )}

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-grid">
          <div>
            <h4>{company?.nama_perusahaan}</h4>
            <img src="/logo.jpg" alt="Logo" className="company-logo" />
          </div>
          <div>
            <h4>Kontak</h4>
            {company?.alamat && <p>📍 {company.alamat}</p>}
            {company?.email && <p>📧 {company.email}</p>}
            {company?.telepon && <p>📞 {company.telepon}</p>}
            {company?.whatsapp && <p>💬 WhatsApp: {company.whatsapp}</p>}
          </div>
          <div>
            <h4>Media & Marketplace</h4>
            {company?.instagram && <a href={company.instagram} target="_blank">Instagram</a>}
            {company?.tiktok && <a href={company.tiktok} target="_blank">TikTok</a>}
            {company?.facebook && <a href={company.facebook} target="_blank">Facebook</a>}
            {company?.shopee && <a href={company.shopee} target="_blank">Shopee</a>}
            {company?.tokopedia && <a href={company.tokopedia} target="_blank">Tokopedia</a>}
            {company?.lazada && <a href={company.lazada} target="_blank">Lazada</a>}
            {company?.website && <a href={company.website} target="_blank">Website</a>}
          </div>
        </div>
        <p className="footer-copy">&copy; 2025 {company?.nama_perusahaan}. All rights reserved.</p>
      </footer>

      {/* Floating WhatsApp */}
      {company?.whatsapp && (
        <a
          href={`https://wa.me/${company.whatsapp.replace(/\s|-/g, "")}`}
          className="wa-floating"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat WhatsApp"
        >
          <FaWhatsapp />
        </a>
      )}
    </div>
  );
}
